import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

emailjs.init('vZ5PqBU7UI8D_jH_2');

export const ContactUs = () => {
  const form = useRef();
  const [submissionStatus, setSubmissionStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    setSubmissionStatus('Sending...');

    emailjs.sendForm(
      'service_qz3fylf',
      'template_ie5jhs4',
      form.current
    )
    .then(
      (result) => {
        console.log('SUCCESS:', result);
        setSubmissionStatus('Success! Your message has been sent.');
        form.current.reset();
      },
      (error) => {
        console.error('FAILED:', error);
        setSubmissionStatus('Error! Failed to send the message.');
      }
    );
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div className="styled-input wide">
        <input type="text" name="name" required />
        <label>Name</label>
      </div>

      <div className="styled-input">
        <input type="email" name="email" required />
        <label>E-mail</label>
      </div>

      <div className="styled-input">
        <input
          type="tel"
          name="phone"
          pattern="[0-9]{10,15}"
          required
        />
        <label>Phone Number</label>
      </div>

      <div className="styled-input wide">
        <textarea name="message" required></textarea>
        <label>Message</label>
      </div>

      <div className="submit-area">
        <input
          className="button"
          type="submit"
          value="Send Message"
        />

        {submissionStatus && <p>{submissionStatus}</p>}
      </div>
    </form>
  );
};